// extracted by mini-css-extract-plugin
module.exports = {"ChatRoom":"ChatRoom_ChatRoom__3qYw2","TopSection":"ChatRoom_TopSection__4CXru","Name":"ChatRoom_Name__3y8Pg"};